import sessionActions from '../actions/SessionActions';
import storeManager from '../store/StoreManager';


// NOTE: Original changes related to Reducing reconnection time is done in https://inspera.atlassian.net/browse/TEII-1344
const CandidateOnlineStatusService = {
    onCandidateOffline: () => {
        window.console.log('We are offline!');
        const store = storeManager.getStore();
        store.dispatch(sessionActions.setNavigatorOfflineState(true));
    },

    onCandidateBackOnline: (AWSIOTService) => {
        window.console.log('We are back online, resurrecting push channel!');
        const store = storeManager.getStore();
        store.dispatch(sessionActions.setNavigatorOfflineState(false));
        setTimeout(() => {
            CandidateOnlineStatusService.onReadyToRetryRefetching(AWSIOTService);
            // we need to wait for some time because chrome detects online event faster than fetch api can use the network
        }, 3000);
    },

    onReadyToRetryRefetching: (AWSIOTService) => {
        AWSIOTService.fetchUrlAndConnect(true);
        // we keep the reconnectTimerId as a failsafe mechanism.
        if (AWSIOTService.reconnectTimerId) {
            clearTimeout(AWSIOTService.reconnectTimerId);
        }
    },
};

export default CandidateOnlineStatusService;
